export interface UrlSegment {
  path: string;
  pathAsString: string;
  parameters: Map<string, any>;
}
